/**
 * Sprint 47, story-232. The web app sends every viewport <= 768px to `/mobile-only`. The
 * one-time account setup page is the exception: an invitee without the app yet opens the emailed
 * link on a phone, and it must render there (it then points them at the app on completion).
 */
export const MOBILE_REDIRECT_EXEMPT_PREFIXES = ['/setup'];

export const isMobileRedirectExempt = (pathname: string): boolean =>
  MOBILE_REDIRECT_EXEMPT_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
